import { FC, useState, useEffect } from 'react';
import Navigator from './Navigator';
import useGetTableColumns from '@/hooks/useGetTableColumns';
import DataTable from '@/components/customUI/DataTable';
import { ObisCodeMapType } from '@/store/hes/types/other';

type SpecialCommandProps = {
  data:
    | { [key: string]: { [key: string]: Record<string, string | number> } }
    | undefined;
  keyOrder?: string[];
  obisCodeMap: ObisCodeMapType;
  failedReason?: string;
};

const SpecialCommands: FC<SpecialCommandProps> = ({
  data,
  keyOrder,
  failedReason,
  obisCodeMap
}) => {
  const navigatorArray = data ? Object.keys(data) : [];

  const [activeKey, setActiveKey] = useState(navigatorArray[0] || '');

  useEffect(() => {
    if (navigatorArray.length > 0) {
      setActiveKey(navigatorArray[0]);
    }
  }, [data]);

  const headers = data && data[activeKey];

  const arrayForTable =
    headers &&
    Object.entries(headers).map(([key, value]) => ({
      TOD_index: key,
      ...value
    }));

  const columns = useGetTableColumns({
    cols: (!failedReason && arrayForTable) || [],
    query: []
  });

  if (failedReason) {
    return <div className="border rounded text-center p-5">{failedReason}</div>;
  }
  if (!data) {
    return (
      <div className="flex text-[#0A3690] justify-center font-bold text-xl items-center">
        No data available!!
      </div>
    );
  }

  return (
    <div className="flex gap-4 h-full">
      <Navigator
        navigationKeys={navigatorArray}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
      <div className="w-full overflow-y-auto scrollbar-custom h-[350px] overflow-x-auto">
        <DataTable
          columnOrder={keyOrder}
          obisCodeMap={obisCodeMap}
          isDownloadable
          columns={columns}
          data={arrayForTable || []}
        />
      </div>
    </div>
  );
};

export default SpecialCommands;
